import clsx from 'clsx';
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide, type SwiperRef } from 'swiper/react';
import { IconButton, Link } from '@trg/tlw-ui-component';
import { useMenuStore } from '../../../stores';

export function MenuDesktopNavBar() {
  const selectedCategory = useMenuStore.use.selectedCategory();
  const selectedSubCategory = useMenuStore.use.selectedSubCategory();
  const setSelectedSubCategory = useMenuStore.use.setSelectedSubCategory();

  const swiperRef = useRef<SwiperRef>(null);
  const [isHideButton, setIsHideButton] = useState(true);

  const updateHideButton = (swiper: SwiperRef['swiper']) => {
    const isHide = !(swiper.allowSlidePrev || swiper.allowSlideNext);
    setIsHideButton(isHide);
  };

  return (
    <nav className="tlw-group/menu-desktop-nav tlw-px-4 tlw-py-2 tlw-flex tlw-justify-between tlw-items-center tlw-gap-3 tlw-overflow-hidden">
      <IconButton
        className="tlw-opacity-0 group-hover/menu-desktop-nav:tlw-opacity-100 group-hover/menu-desktop-nav:tlw-shadow-lg"
        icon="Left"
        type="primary"
        hidden={isHideButton}
        onClick={() => swiperRef.current?.swiper.slidePrev()}
      />

      <div className="tlw-grow tlw-rounded-lg tlw-overflow-hidden tlw-duration-300 group-hover/menu-desktop-nav:tlw-bg-gray-200">
        <Swiper
          ref={swiperRef}
          className="tlw-max-w-full tlw-w-fit"
          slidesPerView="auto"
          spaceBetween={12}
          grabCursor
          onInit={updateHideButton}
          onResize={updateHideButton}
          onUpdate={updateHideButton}
        >
          {selectedCategory?.subCategories.map((item) => (
            <SwiperSlide key={item.title} className="!tlw-w-auto">
              <Link
                className={clsx(
                  'tlw-txt-zh-head-6 tlw-text-txt-700 tlw-block tlw-px-3 tlw-py-2 tlw-duration-300 hover:tlw-text-txt-core',
                  item.title === selectedSubCategory?.title &&
                    'tlw-text-txt-core'
                )}
                href={item.link}
                onMouseEnter={() => setSelectedSubCategory(item)}
              >
                {item.title}
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <IconButton
        className="group-hover/menu-desktop-nav:tlw-shadow-lg"
        icon="Right"
        type="primary"
        hidden={isHideButton}
        onClick={() => swiperRef.current?.swiper.slideNext()}
      />
    </nav>
  );
}
